
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/moje-konto/moj-profil/zmien-adres-email",
      function () {
        return require("private-next-pages/moje-konto/moj-profil/zmien-adres-email/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/moje-konto/moj-profil/zmien-adres-email"])
      });
    }
  